import { useCouponEquipamentList as useCouponEquipmentList } from '@/core/domain/coupon/company/company.hooks';
import { Select, SelectProps } from 'antd';

interface Props extends SelectProps {
  companyId?: number;
}

const CompanySatEquipmentsSelect: React.FC<Props> = ({
  companyId,
  ...props
}) => {
  const couponEquipments = useCouponEquipmentList(companyId);

  return (
    <Select
      {...props}
      loading={couponEquipments.isLoading}
      options={couponEquipments.data?.map((item) => ({
        value: item.id,
        label: item.connectionNumber,
      }))}
    />
  );
};

export default CompanySatEquipmentsSelect;
